import PropTypes from "prop-types";

const ShowWhen = ({ show, ...props }) => {
  if (show) {
    return <>{props.children}</>;
  }

  return <></>;
};

export default ShowWhen;

ShowWhen.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node,
};
